import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  openPagePreviewer,
  closePreviewer,
} from './previewActions'
import {
  selectIsPagePreviewOpened,
  selectPreviewPageId,
  selectIsCanvasPreviewerOpened,
} from './previewSelectors'

export default () => compose(
  connect(
    (state) => ({
      isPagePreviewOpened: selectIsPagePreviewOpened(state),
      previewPageId: selectPreviewPageId(state),
      isCanvasPreviewerOpened: selectIsCanvasPreviewerOpened(state),
    }),
    (dispatch) => (
      bindActionCreators({
        openPagePreviewer,
        closePreviewer,
      }, dispatch)
    ),
  ),
)




// WEBPACK FOOTER //
// ./src/store/preview/withPreview.js